module.exports = __webpack_public_path__ + "img/bootstrap-logo.bed30ddf.jpg";